import UserBasicInfo from './UserBasicInfo';

export default class ResidentBasicInfo {
  constructor(data = {}) {
    this.userInfo = new UserBasicInfo(data.userInfo);
    this.memberSince = data.memberSince;
  }
}
